import { ComparisonTableAction } from "../comparison_table/comparison_table_action";
import { Analytics } from "./analytics";

// バリエーション選択エリアモーダルに紐づけられたフレンドリーページ名
const FNAME_FOR_COMPARISON_TABLE_ADD_MODAL = '比較表追加モーダル';

export class ComparisonTableAnalytics extends Analytics {

  constructor() {
    super();
    ComparisonTableAction.SHOW_COMPARISON_MODAL_EVENT.on((data) => {
      this.run(() => {
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: FNAME_FOR_COMPARISON_TABLE_ADD_MODAL,
          club: {
            server: 'club/pc',
            prop5: FNAME_FOR_COMPARISON_TABLE_ADD_MODAL,
          },
        }
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
      });
    });
  }
}
